<template>
  <div>
    <Head @langChange="langSelect" />
    <section
      class="gameTop TopWarp"
      :style="{
        'background-color': '' + TopBgColor + '',
      }"
    >
      <img :src="TopUrl" alt="" />
      <div class="cont">
        <p class="p1" v-if="TopTitle != ''">{{ TopTitle }}</p>
        <p v-if="TopContent != ''">{{ TopContent }}</p>
      </div>
    </section>
    <section class="gameList newsList cl">
      <div class="items" v-for="(item, index) in NewsList" :key="index">
        <a
          class="img_new_warp"
          :href="['/newsDetail?id=' + item.id + '&language=' + lang]"
        >
          <div class="img_w">
            <img :src="item.cover_img" alt="" />
          </div>
          <div class="new_mask cl">
            <div class="title ell2">{{ item.title }}</div>
            <div class="cont">{{ item.summary }}</div>
            <div class="date">{{ item.publish_time }}</div>
          </div>
        </a>
      </div>
    </section>
    <div v-if="isAchiveBottom" class="loading cl">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <p class="noData" v-if="noMore">NO MORE~</p>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getNews } from "@/common/api.js";
import Head from "@/components/head.vue";
import Foot from "@/components/Foot.vue";

export default {
  name: "Game",
  components: {
    Head,
    Foot,
    getNews,
  },
  data() {
    return {
      TopUrl: "",
      TopBgColor: "",
      TopTitle: "",
      TopContent: "",
      length: 12,
      pageNum: 1,
      NewsList: [],
      isAchiveBottom: false, //滚动条是否到底部标志
      noMore: false, //是否没有数据了
      lang: this.$route.query.language || "zh",
    };
  },
  created() {
    window.addEventListener("touchstart", function (e) {
      e.preventDefault();
    });
    window.addEventListener("touchmove", function (e) {
      e.preventDefault();
    });
    let that = this;
    window.onscroll = () => {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (
        scrollTop + windowHeight >= scrollHeight - 20 &&
        !this.isAchiveBottom &&
        !this.noMore
      ) {
        this.isAchiveBottom = true;
        let that = this;
        //延时触发数据加载
        setTimeout(() => {
          that.pageNum++;
          getNews({
            length: that.length,
            pageNum: that.pageNum,
            language: that.lang,
          }).then((res) => {
            if (res.status == 200) {
              let Data = res.data.data;
              if (Data.NewsList.length == that.length) {
                that.noMore = false;
                that.isAchiveBottom = false;
              } else {
                that.isAchiveBottom = false;
                //没有更多了
                that.noMore = true;
              }
              that.NewsList = that.NewsList.concat(Data.NewsList);
            } else {
              console.log(res.statusText);
            }
          });
        }, 500);
      }
    };
  },
  beforeMount() {
    // 在页面挂载前就发起请求
    this.getWin();
  },
  mounted() {
    let that = this;
    // this.getWin();
    var windowWidth = window.screenWidth;
    window.onresize = () => {
      return (() => {
        //兼容ios浏览器回弹效果
        if (window.screenWidth != windowWidth) {
          that.getWin();
        }
      })();
    };
  },
  methods: {
    getWin() {
      let that = this;
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
      if (that.screenWidth > 1920) {
        that.length = 8;
        that.pageNum = 1;
        that.getNew(8, 1);
      }
      if (that.screenWidth < 1920 || that.screenWidth == 1920) {
        that.length = 12;
        that.pageNum = 1;
        that.getNew(12, 1);
      }
    },
    getNew(len, n) {
      let that = this;
      that.pageNum = 1;
      getNews({
        length: len,
        pageNum: n,
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.TopUrl = Data.TopUrl;
          that.TopBgColor = Data.TopBgColor;
          that.TopTitle = Data.TopTitle;
          that.TopContent = Data.TopContent;
          that.NewsList = Data.NewsList;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      this.getNew();
      this.$refs.foot.langSelect();
    },
    //跳转详情
    Detail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: id, language: this.lang },
      });
    },
  },
  computed: {
    // ...mapState({
    //   lang: (state) => state.lang,
    // }),
  },
};
</script>

<style scoped>
.newsList:after {
  content: "";
  width: 380px;
}
.newsList .item {
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-block;
}
.gameList .item .img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
  z-index: 1;
}
.gameList .item .img::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 70%;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 0, 0, 0),
    rgba(0, 0, 0, 1)
  );
}
.gameList .item .img img {
  width: 100%;
  height: 100%;
}
.gameList .item .cont {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 150px;
  overflow: hidden;
  z-index: 3;
  background: #131313;
  color: #fff;
  padding: 0 30px;
  width: 320px;
  text-align: left;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.gameList .item .cont .title {
  font-size: 24px;
  font-weight: bold;
  padding-top: 30px;
  padding-bottom: 20px;
}
.gameList .item .cont .title a {
  color: #fff;
}
.gameList .item .cont .info {
  width: 320px;
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 18px;
}
.gameList .item .qrWarp {
  opacity: 0;
  transition: all 0.3s;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  height: 350px;
  background: rgba(0, 0, 0, 0.65);
}
.gameList .item:hover .qrWarp {
  opacity: 1;
  transition: all 0.3s;
}

.gameList .item .qrWarp p {
  padding-top: 60px;
  padding-bottom: 35px;
}
.gameList .item .qrWarp a {
  border: 1px solid #fff;
  display: inline-block;
  width: 158px;
  height: 40px;
  border-radius: 5px;
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
}
.gameList .item .qrWarp p img {
  width: 160px;
  height: 160px;
}
.img_new_warp {
  cursor: pointer;
}
</style>





















































// WEBPACK FOOTER //
// src/views/News.vue